import { put, call, takeLatest } from 'redux-saga/effects';
import { base_url, endpoints } from '../../../constants';
import { AxiosService } from '../../../services';
import { actionTypes } from '../../../types';
import { downloadContentForManualUploadFailure, downloadContentForManualUploadSuccess } from '../../actions/InfluencerCampaignActions/downloadContentForManualUploadActions';

function* downloadContentForManualUpload({ payload, callback }) {
    try {
        const response = yield call(AxiosService, {
            method: 'get',
            base_url: base_url,
            endPoint: endpoints.downloadContentForManualUpload + "?campaignId=" + payload?.campaignId,
            isAuth: true,
        });
        console.log('====================================');
        console.log("DOWNLOAD_CONTENT_FOR_MANUAL_UPLOAD_SUCCESS status :", response.data.status);
        console.log("DOWNLOAD_CONTENT_FOR_MANUAL_UPLOAD_SUCCESS data :", response.data.response);
        console.log("DOWNLOAD_CONTENT_FOR_MANUAL_UPLOAD_SUCCESS message :", response.data.message);
        console.log('====================================');
        yield put(
            downloadContentForManualUploadSuccess({
                status: response?.data?.status,
                response: response?.data?.response,
                message: response?.data?.message
            })
        );
        if (callback) {
            callback(
                response?.data?.status,
                response?.data?.response,
                response?.data?.message
            ); // Pass the response data to the callback
        }
    } catch (error) {
        console.log('====================================');
        console.log("DOWNLOAD_CONTENT_FOR_MANUAL_UPLOAD_FAILURE status :", error?.response?.status);
        console.log("DOWNLOAD_CONTENT_FOR_MANUAL_UPLOAD_FAILURE data:", error?.response?.data);
        console.log("DOWNLOAD_CONTENT_FOR_MANUAL_UPLOAD_FAILURE error :", error);
        console.log('====================================');
        yield put(downloadContentForManualUploadFailure({
            status: error?.response?.data?.status,
            response: {},
            message: error?.response?.data?.message
        }));
        if (callback) {
            callback(
                error?.response?.data?.status,
                {},
                error?.response?.data?.message
            ); // Pass the response data to the callback
        }
    }
}

function* downloadContentForManualUploadSaga() {
    yield takeLatest(actionTypes.DOWNLOAD_CONTENT_FOR_MANUAL_UPLOAD_REQUEST, downloadContentForManualUpload);
}

export default downloadContentForManualUploadSaga;
